import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IMLSkill,
    IMLSkillVersion,
    ODataResponse,
} from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';

@Injectable()
export class MLSkillVersionsService extends ODataService<IMLSkillVersion, string> {
    protected _endpoint = '/odata/MLSkillVersions';

    constructor(http: HttpClient) {
        super(http, MapperService.mlSkillVersionMap);
    }

    public getVersions(mlSkillId?: string, queryOptions?: ODataQueryOptions): Observable<ODataResponse<IMLSkillVersion>> {
        return this.get(queryOptions,
            `${this._endpoint}/UiPath.Server.Configuration.OData.GetMLSkillVersions(mlSkillId='${mlSkillId}')`);
    }

    public updateVersion(mlSkillId: string, mlPackageVersionId: string, processor: string) {
        const payload = JSON.stringify({
            mlPackageVersionId: mlPackageVersionId,
            processor,
        });

        return this._http.post<IMLSkill>(
            `${this._endpoint}('${mlSkillId}')/UiPath.Server.Configuration.OData.UpdateMLSkillVersion`, payload);
    }
}
